import React from "react";
import assets from "../../../../../assets/assets";
import { IconController } from "../../../../Scripts/ImgController";
const Rankings = ({
  setSelectedRank,
  selectedRank,
  rank,
  setRankingChanged,
}) => {
  const title = rank.title;
  const rankClickHandler = () => {
    setSelectedRank(title);
    setRankingChanged(true);
  };
  return (
    <div className="flex flex-row items-center gap-2">
      {title === selectedRank ? (
        <div
          onClick={() => {
            // albumUncheckHandler(album.id);
          }}
        >
          <IconController
            src={assets.svg.checkboxChecked}
            className="w-5 h-5 cursor-pointer"
          />
        </div>
      ) : (
        <div
          className="checkbox-unchecked"
          onClick={() => {
            rankClickHandler();
          }}
        ></div>
      )}
      <h5 className="text-xs">{title}</h5>
    </div>
  );
};

export default Rankings;
